import request from '@/plugins/request';
export function MenuList() {
  return request({
    url: '/api/admin/menu',
    method: 'get'
  });
}